module.exports = __webpack_public_path__ + "static/img/logo6@2x.74f275e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/activity/SPSR/logo6@2x.png
// module id = je5Z
// module chunks = 70